import React, { useMemo } from "react";
import { Box } from "@mui/material";
import UserAvatar from "components/UserAvatar";

export default function BlogPostAuthors({ blogPost, authors = [] }) {
  const displayedAuthors = useMemo(() => {
    if (authors?.length) {
      return authors;
    }

    return blogPost?.creator ? [blogPost.creator] : [];
  }, [authors, blogPost]);

  return (
    <>
      <Box flexDirection="column" display="flex">
        <Box display="flex" gap={1} flexWrap="wrap">
          {displayedAuthors.map((author) => (
            <Box key={author.id} py={1}>
              <UserAvatar user={author} enableTooltip={true} />
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
}
